<template>
  <!-- 基本信息 -->
  <ul class="base-info">
    <li v-if="!coordinator">
      <span class="label">{{ $t('public.belong') }}：</span>
      <span class="value">{{ urlFn() }}</span>
    </li>
    <li>
      <span class="label">{{
        coordinator ? $t('integration.name') : $t('device.gateway_name')
      }}：</span>
      <span class="value">
        <i
          :class="gatewayStatusFn(rowData.status)"
          :title="gatewayStatusTitleFn(rowData.status)"
          style="cursor: pointer"
        ></i>
        {{ rowData['name'] }}
      </span>
    </li>

    <li>
      <span class="label">{{ 'mac' }}：</span>
      <span class="value">{{ rowData['mac'] }}</span>
    </li>

    <li>
      <span class="label">{{ $t('device.config_status') }}：</span>
      <span class="value">{{ changeTextFn('config_status', netParams['status']) }}</span>
    </li>

    <li v-if="!coordinator">
      <span class="label">{{ $t('public.carrier') }}：</span>
      <span class="value">{{
        transformMultiCarrier(rowData['carrierName'])
          .map(item => item.name)
          .join(',')
      }}</span>
    </li>

    <li v-if="!coordinator">
      <span class="label">{{ $t('public.type') }}：</span>
      <span class="value">{{ changeTextFn('type', rowData['type']) }}</span>
    </li>
  </ul>
</template>

<script>
import {
  configStatusConvert,
  equiStatusConvert,
  gatewayTypeConvert
} from '@/utils/convert'
import { transformMultiCarrier } from '../../../../../utils/transform/carrierTransform'

export default {
  props: {
    rowData: {},
    coordinator: {
      type: Boolean,
      default: false
    },
    netParams: {
      required: true
    }
  },

  methods: {
    transformMultiCarrier,
    changeTextFn (key, value) {
      if (key === 'type') {
        return this.$t(gatewayTypeConvert(value).title)
      } else {
        return this.$t(configStatusConvert(value).title)
      }
    },
    urlFn () {
      let url = this.rowData.scopeName
      if (this.rowData.sceneName) {
        url += '/' + this.rowData.sceneName
      }
      if (this.rowData.carrierName) {
        url += '/' + this.rowData.carrierName
      }
      return url
    },
    gatewayStatusFn (status) {
      return equiStatusConvert(status).icon
    },
    gatewayStatusTitleFn (status) {
      return this.$t(equiStatusConvert(status).title)
    }
  }
}
</script>
<style lang="scss" scoped>
.base-info {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 10px;
  padding: 10px 20px;

  li {
    display: contents;
  }

  .label {
    text-align: right;
    line-height: 40px;
    color: #606266;
    font-size: 14px;
  }

  .value {
    line-height: 40px;
    color: #606266;
    font-size: 14px;
  }
}
</style>
